/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import {
  Modal,
  Grid,
  Button,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from '@material-ui/core'
import '../../LandingPage/components/LandingActions/LandingActions.scss'

import imageBcie from '../.././../assets/img/image-bcie-3.webp'
// import logoBcie from '../.././../../assets/img/logo-bcie-gtf.png'
import { makeStyles } from '@material-ui/core/styles'
import * as Yup from 'yup'
import { useFormik } from 'formik'

import swal from 'sweetalert'

import { useAuthentication } from '../../../context/authenticationContext'
import { useForm } from '../../../context/formContext'
import Swal from 'sweetalert2'
import { createMiFormByIFI } from '../../../services/Forms/create'
import { getGetUserIfis } from '../../../services/IFI/get'
import { Autocomplete, TextField } from '@mui/material'

const useStyles = makeStyles((theme) => ({
  image: {
    backgroundImage: 'url(' + imageBcie + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('xs')]: {
      visibility: 'hidden',
    },
  },
}))

const ModalRegisterToUser = ({
  open,
  handleClose,
  handleOpenLogin,
  setOpen,
}) => {
  const { userIDB2C, userCountry, IdIFIToken } = useAuthentication()
  const classes = useStyles()
  const {
    miPymesType,
    setPreEligibilityForm,
    preEligibilityForm,
    listCountries,
    getData,
    globalLoading,
  } = useForm()
  const [labelIdentificator, setLabelIdentificator] = useState(null)
  const [selectedCountry, setSelectedCountry] = useState('')
  const [loading, setLoading] = useState(false)
  const [captchaIsValid, setCaptchaIsValid] = useState(false)
  const [handleMessageCaptcha, setHandleMessageCaptcha] = useState(false)
  const [selectedPYME, setSelectedPYME] = useState({})
  const [disabled, setDisabled] = useState(false)
  const [checkErrors, setCheckErrors] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    setSelectedCountry(parseInt(userCountry))
    if (selectedCountry !== '') {
      formik.setFieldValue('taxRegistration', '')
      setLabelIdentificator(
        listCountries.filter(
          (item) => item.IdCountry === parseInt(userCountry),
        ),
      )
    } else {
      formik.setFieldValue('taxRegistration', '')
      setLabelIdentificator(null)
    }
  }, [listCountries])

  const validateFormStatus = () => {
    if (!formik.isValid) {
      alertValidationFields()
    }

    if (formik.values.idMiPymeType === 0) {
      setCheckErrors(true)
      alertValidationFields()
    } else {
      setCheckErrors(false)
    }
  }

  const alertValidationFields = () => {
    Swal.fire({
      icon: 'error',
      title: 'Campos obligatorios',
      text: 'Es necesario completar todos los campos del formulario.',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Reintentar',
    })
  }

  const getUserMIPYMES = async () => {
    try {
      const response = await getGetUserIfis(IdIFIToken)
      if (response.Success) {
        setData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (open) getUserMIPYMES()
  }, [open])

  const DataSchema = Yup.object().shape({
    idMiPymeType: Yup.number().required('Este campo es obligatorio'),
    businessName: Yup.string().required('Este campo es obligatorio'),
    taxRegistration: Yup.string().required('Este campo es obligatorio'),
    b2c: Yup.string().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    initialValues: {
      businessName: '',
      idMiPymeType: '',
      taxRegistration: '',
      b2c: '',
    },
    validationSchema: DataSchema,
    onSubmit: (values) => {
      if (!checkErrors) {
        save()
      }
    },
  })

  const handleCloseModal = () => {
    setOpen(false)
    formik.resetForm()
  }

  const save = () => {
    const payload = {
      TaxRegistration: preEligibilityForm.taxRegistration,
      BusinessName: preEligibilityForm.businessName,
      IdUserAzureB2C: preEligibilityForm.b2c,
      IdMiPymeType: preEligibilityForm.idMiPymeType,
      MIPymeIsCreating: false,
      IdIfi: IdIFIToken,
    }
    createMiFormByIFI(payload)
      .then((res) => {
        if (res.Success) {
          // const mensaje = res.Data
          Swal.fire({
            icon: 'success',
            title: `¡Registro exitoso!`,
            text: `Hemos enviado un correo electrónico a la MIPYME con el enlace de acceso a la plataforma.
            `,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Continuar',
            allowOutsideClick: false,
          }).then(() => {
            handleCloseModal()
          })
        } else {
          const mensaje = res.Message
          Swal.fire({
            icon: 'error',
            title: `¡Error en registro de MIPYME!`,
            text: mensaje,
            confirmButtonColor: '#3085d6',
          })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const close = () => {
    setHandleMessageCaptcha(false)
    setCaptchaIsValid(false)
    handleClose()
    formik.resetForm()
    setDisabled(false)
  }

  const onChange = (value) => {
    if (value) {
      setCaptchaIsValid(true)
      setHandleMessageCaptcha(false)
    } else {
      setCaptchaIsValid(false)
    }
  }

  const validationAlert = () => {
    swal({
      title: 'Campos obligatorios',
      text: `Es necesario completar todos los campos del formulario.`,
      icon: 'error',
      button: 'Reintentar',
    })
  }

  const handleSubmitFunction = () => {
    if (!formik.isValid && !captchaIsValid) {
      validationAlert()
    }

    if (!formik.isValid && captchaIsValid) {
      validationAlert()
    }

    if (formik.isValid && !captchaIsValid) {
      validationAlert()
    }
  }

  const getPatternMiPymeId = () => {
    if (parseInt(userCountry) !== null) {
      switch (parseInt(userCountry)) {
        case 1:
          return '[\\0-9]{0,15}'
        case 2:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 3:
          return '[0-9]{0,15}'
        case 4:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 5:
          return '[0-9]{0,15}'
        case 6:
          return '[sa-zA-ZñÑ0-9]{0,17}'
        case 7:
          return '[0-9]{0,15}'
        default:
          return null
      }
    } else {
      return null
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form id="register-form" onSubmit={formik.handleSubmit}>
          <div className="modal-content-register">
            <Grid
              container
              spacing={1}
              style={{ fontSize: '18px', fontWeight: '400' }}
            >
              <Grid item xs={false} sm={6} md={5} className={classes.image} />
              <Grid item xs={12} sm={6} md={7}>
                <Grid container spacing={1} style={{ padding: '24px 0px' }}>
                  {/* <Grid item xs={12} sm={12} md={12} style={{textAlign: 'center', fontSize: '24px', marginTop: '32px', fontWeight: '500'}}>
                    <img
                      style={{ width: '300px' }}
                      src={logoBcie}
                      alt="React Logo"
                    />
                  </Grid> */}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      textAlign: 'center',
                      fontSize: '24px',
                      marginTop: '16px',
                      fontWeight: '500',
                    }}
                  >
                    <label>Registro MIPYME</label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      textAlign: 'center',
                      fontSize: '16px',
                      marginTop: '5px',
                    }}
                  >
                    <label>
                      Complete todos los campos para registrar una MIPYME
                    </label>
                  </Grid>

                  <Grid
                    container
                    spacing={1}
                    className="input-container-register"
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{
                        marginTop: '5px',
                        color: '#848c95',
                        fontWeight: '500',
                        fontSize: '16px',
                      }}
                    >
                      <label>
                        Usuario
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl style={{ width: '100%' }}>
                        <Autocomplete
                          getOptionLabel={(option) =>
                            // `${option.TaxRegistration}` +
                            // ' / ' +
                            // option.BusinessName
                            `${option.Name}` +
                            ' ' +
                            `${option.LastName}` +
                            ' - ' +
                            option.EMail
                          }
                          disablePortal
                          id="combo-box-demo"
                          options={data}
                          // value={result[0]}
                          sx={{ width: '100%' }}
                          renderInput={(params) => <TextField {...params} />}
                          onChange={(e, value) => {
                            formik.setValues({
                              ...formik.values,
                              b2c: value.IdUserAzureB2C,
                            })
                            setPreEligibilityForm({
                              ...preEligibilityForm,
                              b2c: value.IdUserAzureB2C,
                            })
                          }}
                        />
                        {formik.errors.b2c ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.b2c}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{
                        marginTop: '5px',
                        color: '#848c95',
                        fontWeight: '500',
                        fontSize: '16px',
                      }}
                    >
                      <label>
                        Nombre de la MIPYME{' '}
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl style={{ width: '100%' }}>
                        <TextField
                          id="businessName"
                          style={{ width: '100%' }}
                          error={formik.errors.businessName}
                          variant="outlined"
                          onChange={(e) => {
                            if (e.target.validity.valid) {
                              formik.setFieldValue(
                                'businessName',
                                e.target.value,
                              )

                              setPreEligibilityForm({
                                ...preEligibilityForm,
                                businessName: e.target.value,
                              })
                            }
                          }}
                          value={formik.values.businessName}
                          inputProps={{
                            maxLength: 64,
                            autoComplete: 'off',
                            // pattern: '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,64}',
                          }}
                        />
                        {formik.errors.businessName ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.businessName}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      style={{ marginTop: '5px' }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          color: '#848c95',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        <label>
                          Tipo MIPYME <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <Select
                            id="idMiPymeType"
                            value={formik.values.idMiPymeType}
                            onChange={(e) => {
                              formik.setFieldValue(
                                'idMiPymeType',
                                e.target.value,
                              )
                              setPreEligibilityForm({
                                ...preEligibilityForm,
                                idMiPymeType: e.target.value,
                              })
                            }}
                            variant="outlined"
                            error={formik.errors.idMiPymeType}
                          >
                            <MenuItem value={''} disabled>
                              Seleccione una opción
                            </MenuItem>
                            {miPymesType &&
                              miPymesType.map((item, key) => (
                                <MenuItem key={key} value={item.IdMiPymeType}>
                                  {item.Description}
                                </MenuItem>
                              ))}
                          </Select>
                          {formik.errors.idMiPymeType ? (
                            <div
                              style={{
                                color: 'red',
                                marginTop: '3px',
                                fontSize: '13px',
                              }}
                            >
                              {formik.errors.idMiPymeType}
                            </div>
                          ) : null}
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      style={{ marginTop: '5px' }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          color: '#848c95',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        <label>
                          Identificador MIPYME{' '}
                          {labelIdentificator
                            ? `(${labelIdentificator[0]?.LabelIdentification.Denomination})`
                            : null}{' '}
                          <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <TextField
                            id="taxRegistration"
                            style={{ width: '100%' }}
                            error={formik.errors.taxRegistration}
                            variant="outlined"
                            value={formik.values.taxRegistration}
                            inputProps={{
                              autoComplete: 'off',
                              pattern: getPatternMiPymeId(),
                            }}
                            onChange={(e) => {
                              if (e.target.validity.valid) {
                                formik.setFieldValue(
                                  'taxRegistration',
                                  e.target.value,
                                )
                                setPreEligibilityForm({
                                  ...preEligibilityForm,
                                  taxRegistration: e.target.value,
                                })
                              }
                            }}
                          />
                          {formik.errors.taxRegistration ? (
                            <div
                              style={{
                                color: 'red',
                                marginTop: '3px',
                                fontSize: '13px',
                              }}
                            >
                              {formik.errors.taxRegistration}
                            </div>
                          ) : null}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '5px',
                      textAlign: 'center',
                      padding: '8px 24px',
                    }}
                    justifyContent="center"
                    direction="row"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12} md={6}>
                      <Button
                        variant="contained"
                        style={{
                          background:
                            'linear-gradient(135deg, #004bce 11%, #2bce75 100%)',
                          color: 'white',
                          height: '45px',
                          width: '100%',
                        }}
                        type="submit"
                        onClick={() => validateFormStatus()}
                      >
                        Registrar
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      <Button
                        variant="outlined"
                        style={{ height: '45px', width: '100%' }}
                        onClick={() => handleCloseModal()}
                      >
                        Cancelar
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </form>
      </Modal>
    </>
  )
}

export default React.memo(ModalRegisterToUser)
